import React, { Component } from "react";
import { Col, Row, Form, Button, Card } from "react-bootstrap";
import Pagination from "../../Pagination/Pagination";
import classes from "./extInterview.module.css";
//import { NavLink } from 'react-router-dom'
//import search from '../../../Assets/icons/0.75x/searchldpi.png';
import recommend from "../../../Assets/icons/1.5x/Bighdpi.png";
import { connect } from "react-redux";
//import ViewExternalInterviewer from '../interviewerProfileView/interviewProfileView.jsx'
import * as actionTypes from "../../../Action/Index";
import Loader from "react-loader-advanced";
//import Spinner from 'react-bootstrap/Spinner';
import NoDataErrorScreen from "../../commonComponents/NoDataErrorScreen";
import ServerErrorScreen from "../../commonComponents/ServerErrorScreen";
//import './progressbar.css'
import Modal from "./ScheduleInterviewerProfileView/interviewProfileView";
//import Availability from './Availability';
import AvailabilitySecond from "./AvailabilitySecond";
import loading from "../../../Assets/Images/loader-green.gif";
//import SweetAlert from '../commonComponents/SweetAlert';
import NewSweetAlert from "react-bootstrap-sweetalert";
import SweetAlert from "react-bootstrap-sweetalert";
import labels from "../../../Labels/Label";
import "../../commonComponents/SweetAlert.css";
import DatePicker from "react-datepicker";
import calendar from "../../../Assets/icons/1x/datemdpi.png";
//import clock from '../../Assets/icons/1x/timemdpi.png'
import moment from "moment";
import { withRouter } from "react-router-dom";
import Cookies from "universal-cookie";
import Check from "../../../Assets/Images/circle.png";
class candidateProfile extends Component {
  constructor(props) {
    super(props);
    // var newDate= new Date(new Date())
    this.state = {
      currentPage: 1,
      searchItem: "",
      interviewerError: "",
      slotError: "",
      show: false,
      email: "",
      image: "",
      id: "",
      availability: "",
      availabilityModal: false,
      interviewerId: "",
      interviwerRadioId: "",
      selectId: "",
      scheduleInterviewInterviewerList: [],
      prevLimit: 0,
      nextLimit: 6,
      remainingBalance: 0,
      interviewerAmount: 0,
      records: 0,
      totalInterviewTaken: 0,
      notifyFail: false,
      notifySuccess: false,
      startDate: null, // new Date(new Date()),
      endDate: null, //newDate.setDate(newDate.getDate()+1),
      startTime: null, //new Date("Mon Feb 03 2020 00:00:00 GMT+0530 (India Standard Time)") ,
      endTime: null, // new Date("Mon Feb 03 2020 23:30:00 GMT+0530 (India Standard Time)") ,
      interviewerId: null,
      startDatevalidation: false,
      endDatevalidation: false,
      userType: localStorage.getItem("userType"),
      candidateId: localStorage.getItem("candidateId"),
      jobProfileId: localStorage.getItem("jobProfileId"),
      selectedDuration: localStorage.getItem("selectedDuration"),
      DatevalidationerrorMsg: "",
      // timerangevalidation:false,
      startDatenew: null,
      timeSlotnew: null,
      isClear: false,
      todaycss: {
        border: "1px solid #d0d0e1",
        borderRadius: "7px",
        fontSize: "14px",
        padding: "3px 0px 3px 0px",
        cursor: "pointer",
        width: "150px",
        textAlign: "center",
        height: "30px",
      },
      tomorrowcss: {
        border: "1px solid #d0d0e1",
        borderRadius: "7px",
        fontSize: "14px",
        padding: "3px 0px 3px 0px",
        cursor: "pointer",
        width: "150px",
        textAlign: "center",
        height: "30px",
      },
      choosedatecss: {
        border: "1px solid #d0d0e1",
        borderRadius: "7px",
        fontSize: "14px",
        padding: "3px 20px 3px 0px",
        cursor: "pointer",
        width: "150px",
        textAlign: "center",
        display: "flex",
        justifyContent: "flex-end",
        height: "30px",
      },
    };
  }

  SchedulingCouncelling = () => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let dateTime = this.props.text?.split("-");
    let formatedDate = dateTime[0]?.split(" ");
    let monthinNo = months.indexOf(formatedDate[1]);
    let currentMonth = new Date().getMonth();
    let year = new Date().getFullYear();

    if (currentMonth > monthinNo) {
      year = year + 1;
    }

    let finalDate = formatedDate.join("-") + year;

    this.setState(() => {
      let date =
        this.state.startDatenew == null
          ? ""
          : moment(this.state.startDatenew).format("YYYY-MM-DD");

      let timeSlot = this.props.timeslotFilter;

      const interviewDate =
        this.state.scheduleInterviewInterviewerList[0]?.interviewDate;

      let interviewStartTime = moment(dateTime[1], "h:mm A");

      let interviewDuration =
        this.state.scheduleInterviewInterviewerList[0]?.interviewDuration || 30;

      let interviewEndTime = interviewStartTime
        .clone()
        .add(interviewDuration, "minutes")
        .format("hh:mm A");

      let data = {
        amount: this.state.interviewerAmount,
        duration: interviewDuration,
        endTime: interviewEndTime,
        interviewDate: finalDate,
        interviewerId: this.state.interviewerId,
        modeofinterview: "Video",
        startTime: dateTime[1],
      };

      this.props.scheduleCounselling(this.state.currentPage, data);
    });
  };

  handleSubmit = (event) => {
    if (this.props.checkDuplicateResult === false) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  onRadioSelect = (e) => {
    //const cryptr = new Cryptr('foxmatrix#brijesh@atishay$nikhil');

    this.setState({
      interviewerId: e.target.value,
      text: e.target.value,
    });

    this.props.onRadioSelect(e.target.value);
    this.matchIds();
  };
  availabilityModalHandler = () => {
    this.setState({
      availabilityModal: false,
    });
  };
  handleModal = (totalInterviewTaken, ev, picture, id) => {
    this.setState({
      show: !this.state.show,
      email: ev,
      image: picture,
      id: id,
      totalInterviewTaken: totalInterviewTaken,
    });
    console.log("handleModal called");
  };

  onPageChange = (id) => {
    this.setState({
      currentPage: 1,
    });
  };
  onLeftChange = () => {
    if (this.state.currentPage == 1) {
      return;
    }
    this.setState(
      {
        currentPage: this.state.currentPage - 1,
      },
      () => {
        let date =
          this.state.startDatenew == null
            ? ""
            : moment(this.state.startDatenew).format("YYYY-MM-DD");
        let timeSlot = this.props.timeslotFilter;
        let data = {
          interviewerNameOrDomain: "",
          jobProfileId: this.props.selectedJobProfileId.id,
          modeOfInterview: this.props.selectedMode,
          candidateId: 0,
          date: date,
          timeSlot: timeSlot,
        };
        this.props.getScheduleInterviwerList(this.state.currentPage, data);
      }
    );
  };
  onRightChange = () => {
    if (this.props.records == this.state.currentPage) {
      return;
    }
    this.setState(
      {
        currentPage: this.state.currentPage + 1,
      },
      () => {
        let date =
          this.state.startDatenew == null
            ? ""
            : moment(this.state.startDatenew).format("YYYY-MM-DD");
        let timeSlot = this.props.timeslotFilter;
        let data = {
          candidateId: this.state.candidateId,
          date: date,
          interviewDuration:
            this.state.scheduleInterviewInterviewerList[0].interviewDuration,
          interviewerNameOrDomain: "",
          jobProfileId: this.state.jobProfileId,
          modeOfInterview: "Video",
          timeSlot: timeSlot,
        };
        this.props.getScheduleInterviwerList(this.state.currentPage, data);
      }
    );
  };

  componentDidMount() {
    this.state.isClear = false;
    let newDate = new Date(new Date());
    let tomorrow = new Date(newDate.setDate(newDate.getDate() + 1));
    if (this.props.availabilityFilter != "" && this.props.type == "today") {
      this.state.currentPage = 1;
      this.setState({
        startDatenew: new Date(),
        todaycss: {
          backgroundColor: "#05c6b3",
          borderRadius: "7px",
          fontSize: "14px",
          padding: "3px 0px 3px 0px",
          cursor: "pointer",
          width: "150px",
          textAlign: "center",
          height: "30px",
        },
        tomorrowcss: {
          border: "1px solid #d0d0e1",
          borderRadius: "7px",
          fontSize: "14px",
          padding: "3px 0px 3px 0px",
          cursor: "pointer",
          width: "150px",
          textAlign: "center",
          height: "30px",
        },
        choosedatecss: {
          border: "1px solid #d0d0e1",
          borderRadius: "7px",
          fontSize: "14px",
          padding: "3px 20px 3px 0px",
          cursor: "pointer",
          width: "150px",
          textAlign: "center",
          display: "flex",
          justifyContent: "flex-end",
          height: "30px",
        },
      });
    } else if (
      this.props.availabilityFilter != "" &&
      this.props.type == "tomorrow"
    ) {
      this.state.currentPage = 1;
      this.setState({
        startDatenew: tomorrow,
        todaycss: {
          border: "1px solid #d0d0e1",
          borderRadius: "7px",
          fontSize: "14px",
          padding: "3px 0px 3px 0px",
          cursor: "pointer",
          width: "150px",
          textAlign: "center",
          height: "30px",
        },
        tomorrowcss: {
          backgroundColor: "#05c6b3",
          borderRadius: "7px",
          fontSize: "14px",
          padding: "3px 0px 3px 0px",
          cursor: "pointer",
          width: "150px",
          textAlign: "center",
          height: "30px",
        },
        choosedatecss: {
          border: "1px solid #d0d0e1",
          borderRadius: "7px",
          fontSize: "14px",
          padding: "3px 20px 3px 0px",
          cursor: "pointer",
          width: "150px",
          textAlign: "center",
          display: "flex",
          justifyContent: "flex-end",
          height: "30px",
        },
      });
    } else if (
      this.props.availabilityFilter != "" &&
      this.props.type == "other"
    ) {
      this.setState({
        startDate: this.props.availabilityFilter,
        startDatenew: this.props.availabilityFilter,
        todaycss: {
          border: "1px solid #d0d0e1",
          borderRadius: "7px",
          fontSize: "14px",
          padding: "3px 0px 3px 0px",
          cursor: "pointer",
          width: "150px",
          textAlign: "center",
          height: "30px",
        },
        tomorrowcss: {
          border: "1px solid #d0d0e1",
          borderRadius: "7px",
          fontSize: "14px",
          padding: "3px 0px 3px 0px",
          cursor: "pointer",
          width: "150px",
          textAlign: "center",
          height: "30px",
        },
        choosedatecss: {
          backgroundColor: "#05c6b3",
          borderRadius: "7px",
          fontSize: "14px",
          padding: "3px 20px 3px 0px",
          cursor: "pointer",
          width: "150px",
          textAlign: "center",
          display: "flex",
          justifyContent: "flex-end",
          height: "30px",
        },
      });
    }
    if (this.props.nameFilter != "") {
      this.state.currentPage = 1;
      //this.searchField.value=this.props.nameFilter
    }
    //  if(this.props.timeslotFilter!=""){
    //     document.getElementById(this.props.timeslotFilter).selected=true
    // }

    let date =
      this.props.availabilityFilter == ""
        ? ""
        : moment(this.props.availabilityFilter).format("YYYY-MM-DD");
    let timeSlot = this.props.timeslotFilter;
    let data = {
      candidateId: this.state.candidateId,
      date: date,
      interviewDuration: this.state.selectedDuration,
      interviewerNameOrDomain: "",
      jobProfileId: this.state.jobProfileId,
      modeOfInterview: "Video",
      timeSlot: timeSlot,
    };

    this.props.getScheduleInterviwerList(this.state.currentPage, data);
  }

  componentWillReceiveProps(nextProps) {
    // if (nextProps.sufficientBalance != true) {
    //   this.props.history.push("/interview");
    // }
    if (
      this.props.timeslotFilter !== nextProps.timeslotFilter &&
      nextProps.timeslotFilter !== null
    ) {
      this.setState({
        timeSlotnew: this.props.timeslotFilter,
      });
    }
    if (
      nextProps.notifyFoxmatrixSuceess !== this.props.notifyFoxmatrixSuceess
    ) {
      this.setState({
        notifySuccess: nextProps.notifyFoxmatrixSuceess,
      });
    }

    if (
      nextProps.notifyFoxmatrixFailMsg !== this.props.notifyFoxmatrixFailMsg
    ) {
      this.setState({
        notifyFail: nextProps.notifyFoxmatrixFailMsg,
      });
    }
    if (nextProps.scheduleInterviewInterviewerList != null) {
      this.setState({
        scheduleInterviewInterviewerList:
          nextProps.scheduleInterviewInterviewerList,
        remainingBalance: nextProps.remainingBalance,
        records: nextProps.records,
        notifyFail: nextProps.notifyFoxmatrixFailMsg,
        notifySuccess: nextProps.notifyFoxmatrixSuceess,
      });
    }
  }
  handleSubmit = (event) => {
    if (this.props.checkDuplicateResult === false) {
      event.preventDefault();
      event.stopPropagation();
    }
  };
  // handleSubmit = (event) => {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   this.setState({
  //     currentPage: 1,
  //   });
  //   const newarr = "";
  //   let data = {
  //     //   interviewerNameOrDomain: newarr,
  //     //   jobProfileId: this.props.selectedJobProfileId.id,
  //     //   modeOfInterview: this.props.selectedMode,
  //     //   candidateId: this.props.candidateId,
  //     //   date:
  //     //     this.state.startDatenew == null
  //     //       ? ""
  //     //       : moment(this.state.startDatenew).format("YYYY-MM-DD"),
  //     //   timeSlot: this.props.timeslotFilter,
  //     // };
  //     candidateId: 39,
  //     date: "2024-03-24",
  //     interviewDuration: 30,
  //     interviewerNameOrDomain: "abc",
  //     jobProfileId: 3998,
  //     modeOfInterview: "Video",
  //     timeSlot: 23,
  //   };
  //   this.props.saveFilterByName("");
  //   this.props.getScheduleInterviwerList(this.state.currentPage, data);
  // };

  check = (event) => {
    let x = document.getElementsByTagName("tr");
    let i;
    for (i = 0; i < x.length; i++) {
      x[i].style.boxShadow = "none";
    }
    //event.target.parentNode.parentNode.parentNode.style.boxShadow = "0px 0px 0px 1px #00a99d"
  };

  availableCheck = () => {
    this.props.handleJobProfilePage("paymentPreview", {
      dateTime: this.props.text,
      amount: this.state.interviewerAmount,
      position: this.state.position,
      years: this.state.expYears,
      months: this.state.expMonths,
    });
    // this.setState({ interviewerError: "Please select an interviewer profile" })
  };

  hideAlert_1 = () => {
    this.setState({
      interviewerError: "",
    });
  };

  hideAlert_2 = () => {
    this.setState(
      {
        slotError: "",
        notifyFail: false,
        notifySuccess: false,
      },
      () => {
        this.props.clearStateNotify();
      }
    );
  };

  matchIds = () => {
    if (this.props.id !== this.state.selectId) {
      this.props.onRadioUnselectInterviewer();
      this.props.onRadioSelectInterviewer({ id: this.state.id });
    }
  };

  notifyInterviewer = () => {
    let data = [this.props.selectedJobProfileId.id, ""];
    this.props.notifyFoxmatrix(data);
  };

  i = 0;

  // clearTimevalidation=()=>{
  //     this.setState({
  //         timerangevalidation:false
  //     })
  // }
  ClearByDateTime = () => {
    this.setState(
      {
        currentPage: 1,
      },
      () => {
        //this.searchField.value=""
        let data = {
          interviewerNameOrDomain: "",
          jobProfileId: this.props.selectedJobProfileId.id,
          modeOfInterview: this.props.selectedMode,
          candidateId: this.props.candidateId,
          date:
            this.state.startDatenew == null
              ? ""
              : moment(this.state.startDatenew).format("YYYY-MM-DD"),
          timeSlot: this.props.timeslotFilter,
        };
        this.props.saveFilterByName("");
        this.props.getScheduleInterviwerList(this.state.currentPage, data);
      }
    );
  };
  // clearFilterDate=()=>{
  //     this.setState({
  //         startDatevalidation:false,
  //         endDatevalidation:false,
  //         DatevalidationerrorMsg:""
  //      })
  // }

  nextClicked = () => {
    var checkboxes = document.getElementsByTagName("input");
    let toggle = false;
    let interviewerId = null;
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].type == "radio" && checkboxes[i].checked == true) {
        toggle = true;
        interviewerId = checkboxes[i].id;
      }
    }
    if (toggle && document.getElementById(interviewerId) != null) {
      document.getElementById(interviewerId).click();
    } else {
      this.setState({
        slotError: " Please select the interviewer and Availability slot",
      });
    }
  };

  filterByDate = (e) => {
    this.state.isClear = false;
    let newDate = new Date(new Date());
    let tomorrow = new Date(newDate.setDate(newDate.getDate() + 1));
    let name = document.getElementsByName("availability");

    this.state.startDate = null;
    for (let i = 0; i < name.length; i++) {
      if (name[i].checked === true && name[i].value === "today") {
        this.state.currentPage = 1;
        this.setState(
          {
            startDatenew: new Date(),
            todaycss: {
              backgroundColor: "#05c6b3",
              border: "1px solid #05c6b3",
              borderRadius: "7px",
              fontSize: "14px",
              padding: "3px 0px 3px 0px",
              cursor: "pointer",
              width: "150px",
              textAlign: "center",
              height: "30px",
            },
            tomorrowcss: {
              border: "1px solid #d0d0e1",
              borderRadius: "7px",
              fontSize: "14px",
              padding: "3px 0px 3px 0px",
              cursor: "pointer",
              width: "150px",
              textAlign: "center",
              height: "30px",
            },
            choosedatecss: {
              border: "1px solid #d0d0e1",
              borderRadius: "7px",
              fontSize: "14px",
              padding: "3px 20px 3px 0px",
              cursor: "pointer",
              width: "150px",
              textAlign: "center",
              display: "flex",
              justifyContent: "flex-end",
              height: "30px",
            },
          },
          () => {
            let date =
              this.state.startDatenew == null
                ? ""
                : moment(this.state.startDatenew).format("YYYY-MM-DD");
            let timeSlot = this.props.timeslotFilter;
            let data = {
              candidateId: this.state.candidateId,
              date: date,
              interviewDuration: this.state.selectedDuration,
              interviewerNameOrDomain: "",
              jobProfileId: this.state.jobProfileId,
              modeOfInterview: "Video",
              timeSlot: timeSlot,
            };
            this.props.saveFilters(this.state.startDatenew, "today");
            this.props.getScheduleInterviwerList(this.state.currentPage, data);
          }
        );
      } else if (name[i].checked === true && name[i].value === "tomorrow") {
        this.state.currentPage = 1;
        this.setState(
          {
            startDatenew: tomorrow,
            todaycss: {
              border: "1px solid #d0d0e1",
              borderRadius: "7px",
              fontSize: "14px",
              padding: "3px 0px 3px 0px",
              cursor: "pointer",
              width: "150px",
              textAlign: "center",
              height: "30px",
            },
            tomorrowcss: {
              backgroundColor: "#05c6b3",
              border: "1px solid #05c6b3",
              borderRadius: "7px",
              fontSize: "14px",
              padding: "3px 0px 3px 0px",
              cursor: "pointer",
              width: "150px",
              textAlign: "center",
              height: "30px",
            },
            choosedatecss: {
              border: "1px solid #d0d0e1",
              borderRadius: "7px",
              fontSize: "14px",
              padding: "3px 20px 3px 0px",
              cursor: "pointer",
              width: "150px",
              textAlign: "center",
              display: "flex",
              justifyContent: "flex-end",
              height: "30px",
            },
          },
          () => {
            let date =
              this.state.startDatenew == null
                ? ""
                : moment(this.state.startDatenew).format("YYYY-MM-DD");
            let timeSlot = this.props.timeslotFilter;
            let data = {
              candidateId: this.state.candidateId,
              date: date,
              interviewDuration: this.state.selectedDuration,
              interviewerNameOrDomain: "",
              jobProfileId: this.state.jobProfileId,
              modeOfInterview: "Video",
              timeSlot: timeSlot,
            };
            this.props.saveFilters(this.state.startDatenew, "tomorrow");
            this.props.getScheduleInterviwerList(this.state.currentPage, data);
          }
        );
      }
    }
  };
  filterByTimeSlot = (e) => {
    this.state.currentPage = 1;
    this.setState({ timeSlotnew: e.target.value }, () => {
      let date =
        this.state.startDatenew == null
          ? ""
          : moment(this.state.startDatenew).format("YYYY-MM-DD");
      let timeSlot = this.props.timeslotFilter;
      let data = {
        candidateId: this.state.candidateId,
        date: date,
        interviewDuration: this.state.selectedDuration,
        interviewerNameOrDomain: "",
        jobProfileId: this.state.jobProfileId,
        modeOfInterview: "Video",
        timeSlot: timeSlot,
      };
      this.props.saveFilterTimeSlot(this.state.timeSlotnew);

      this.props.getScheduleInterviwerList(this.state.currentPage, data);
    });
  };

  clearFilters = (x) => {
    let name = document.getElementsByName("availability");
    this.state.currentPage = 1;
    if (x == 1) {
      for (let i = 0; i < name.length; i++) {
        name[i].checked = false;
        this.state.isClear = true;
      }
      this.setState({ startDatenew: null, startDate: null }, () => {
        let date =
          this.state.startDatenew == null
            ? ""
            : moment(this.state.startDatenew).format("YYYY-MM-DD");
        let timeSlot = this.props.timeslotFilter;
        let data = {
          candidateId: this.state.candidateId,
          date: date,
          interviewDuration: this.state.selectedDuration,
          interviewerNameOrDomain: "",
          jobProfileId: this.state.jobProfileId,
          modeOfInterview: "Video",
          timeSlot: timeSlot,
        };
        this.props.saveFilters(data.date, "none");
        this.props.getScheduleInterviwerList(this.state.currentPage, data);
      });
    } else if (x == 2) {
      this.setState({ timeSlotnew: null }, () => {
        document.getElementById("timeslot").options[0].selected = true;
        let date =
          this.state.startDatenew == null
            ? ""
            : moment(this.state.startDatenew).format("YYYY-MM-DD");
        let timeSlot = this.props.timeslotFilter;
        let data = {
          candidateId: this.state.candidateId,
          date: date,
          interviewDuration: this.state.selectedDuration,
          interviewerNameOrDomain: "",
          jobProfileId: this.state.jobProfileId,
          modeOfInterview: "Video",
          timeSlot: timeSlot,
        };
        this.props.saveFilterTimeSlot(data.timeSlot);
        this.props.getScheduleInterviwerList(this.state.currentPage, data);
      });
    }
  };

  setStartDate = (date) => {
    this.state.isClear = false;
    let name = document.getElementsByName("availability");
    for (let i = 0; i < name.length; i++) {
      name[i].checked = false;
    }
    for (let i = 0; i < name.length; i++) {
      if (name[i].value == "choosedate") {
        name[i].checked = true;
      }
    }

    this.setState(
      {
        startDate: date,
        startDatenew: date,
        todaycss: {
          border: "1px solid #d0d0e1",
          borderRadius: "7px",
          fontSize: "14px",
          padding: "3px 0px 3px 0px",
          cursor: "pointer",
          width: "150px",
          textAlign: "center",
          height: "30px",
        },
        tomorrowcss: {
          border: "1px solid #d0d0e1",
          borderRadius: "7px",
          fontSize: "14px",
          padding: "3px 0px 3px 0px",
          cursor: "pointer",
          width: "150px",
          textAlign: "center",
          height: "30px",
        },
        choosedatecss: {
          backgroundColor: "#05c6b3",
          borderRadius: "7px",
          fontSize: "14px",
          padding: "3px 20px 3px 0px",
          cursor: "pointer",
          width: "150px",
          textAlign: "center",
          display: "flex",
          justifyContent: "flex-end",
          height: "30px",
        },
      },
      () => {
        this.state.currentPage = 1;
        let date =
          this.state.startDatenew == null
            ? ""
            : moment(this.state.startDatenew).format("YYYY-MM-DD");
        let timeSlot = this.props.timeslotFilter;
        let data = {
          candidateId: this.state.candidateId,
          date: date,
          interviewDuration: this.state.selectedDuration,
          interviewerNameOrDomain: "",
          jobProfileId: this.state.jobProfileId,
          modeOfInterview: "Video",
          timeSlot: timeSlot,
        };
        this.props.saveFilters(this.state.startDatenew, "other");
        this.props.getScheduleInterviwerList(this.state.currentPage, data);
      }
    );
  };

  searchHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.keyCode == 13) {
      this.state.currentPage = 1;
      const newarr = "";
      let data = {
        interviewerNameOrDomain: newarr,
        jobProfileId: this.props.selectedJobProfileId.id,
        modeOfInterview: this.props.selectedMode,
        candidateId: this.props.candidateId,
        date:
          this.state.startDatenew == null
            ? ""
            : moment(this.state.startDatenew).format("YYYY-MM-DD"),
        timeSlot: this.props.timeslotFilter,
      };
      this.props.saveFilterByName("");
      this.props.getScheduleInterviwerList(this.state.currentPage, data);
    }
  };

  render() {
    if (this.state.startDate != null) {
      let currentDate = new Date(this.state.startDate);
      currentDate.setDate(currentDate.getDate() + 14);
      //  var Dayafter15=new Date(currentDate)
    }

    let Dayafter15 = new Date();
    Dayafter15.setDate(Dayafter15.getDate() + 15);

    let today = moment(new Date()).format("DD MMM");

    let newDate = new Date(new Date());
    let tomorrow = new Date(newDate.setDate(newDate.getDate() + 1));
    let tomorrowFormated = moment(tomorrow).format("DD MMM");

    if (this.state.isClear === true) {
      this.state.todaycss = {
        border: "1px solid #d0d0e1",
        borderRadius: "7px",
        fontSize: "14px",
        padding: "3px 0px 3px 0px",
        cursor: "pointer",
        width: "150px",
        textAlign: "center",
        height: "30px",
      };
      this.state.tomorrowcss = {
        border: "1px solid #d0d0e1",
        borderRadius: "7px",
        fontSize: "14px",
        padding: "3px 0px 3px 0px",
        cursor: "pointer",
        width: "150px",
        textAlign: "center",
        height: "30px",
      };
      this.state.choosedatecss = {
        border: "1px solid #d0d0e1",
        borderRadius: "7px",
        fontSize: "14px",
        padding: "3px 20px 3px 0px",
        cursor: "pointer",
        width: "150px",
        textAlign: "center",
        display: "flex",
        justifyContent: "flex-end",
        height: "30px",
      };
    }

    return (
      <>
        {/* <Row>
                    <Col md={3}>
                        <div className={classes.heading}>
                            <h4>Schedule Interview</h4>
                        </div>

                    </Col>
                    <Col md={9} className="justify-content-md-center">
                        <ul className="progress-tracker progress-tracker--text progress-tracker--text-inline progress-tracker--spaced">

                            <li className="progress-step is-complete">

                                <div className="progress-marker" data-text="1">
                                    <div className="progress-text">
                                        <h6 className="progress-title color">Job Profile</h6>
                                    </div>
                                </div>
                            </li>

                            <li className="progress-step is-complete">
                                <div className="progress-marker" data-text="2">
                                    <div className="progress-text">
                                        <h6 className="progress-title color">Candidate Profile</h6>
                                    </div>
                                </div>
                            </li>

                            <li className="progress-step is-active" aria-current="step">
                                <div className="progress-marker" data-text="3">
                                    <div className="progress-text">
                                        <h6 className="progress-title color">Interviewer</h6>
                                    </div>
                                </div>
                            </li>

                            <li className="progress-step">
                                <div className="progress-marker" data-text="4">
                                    <div className="progress-text">
                                        <h6 className="progress-title">Interview Details</h6>
                                    </div>
                                </div>
                            </li>

                        </ul>
                        
                    </Col>
                </Row> */}

        <Row>
          <Col md={2}></Col>
          <Col md={2}>
            <span className={classes.filter}>Filters</span>
          </Col>
        </Row>

        <Row>
          <Col md={2}></Col>
          <Col
            md={6}
            style={{
              borderRight: "1px solid #d0d0e1",
              padding: "0px 19px 0px 17px",
              backgroundColor: "white",
            }}
          >
            <div className={classes.filterByAvailability}>
              <span>Availability</span>
              <span
                className={classes.filterClear}
                onClick={() => this.clearFilters(1)}
              >
                Clear
              </span>
            </div>

            <div className={classes.filterByAvailability}>
              <label style={this.state.todaycss}>
                <input
                  type="radio"
                  name="availability"
                  onChange={this.filterByDate.bind(this)}
                  value="today"
                />
                <span>Today ({today})</span>
              </label>

              <label style={this.state.tomorrowcss}>
                <input
                  type="radio"
                  name="availability"
                  onChange={this.filterByDate.bind(this)}
                  value="tomorrow"
                />
                <span>Tomorrow ({tomorrowFormated})</span>
              </label>

              <label>
                <input
                  type="radio"
                  name="availability"
                  onChange={() => {
                    this.dateSelect.setFocus();
                  }}
                  value="choosedate"
                />
                <DatePicker
                  selected={this.state.startDate}
                  onChange={(date) => this.setStartDate(date)}
                  minDate={new Date()}
                  maxDate={Dayafter15}
                  customInput={
                    <label style={this.state.choosedatecss}>
                      <span
                        style={{
                          marginRight: this.state.startDate !== null && "20px",
                        }}
                      >
                        {this.state.startDate == null
                          ? "Choose Date"
                          : moment(this.state.startDate).format("DD MMM")}
                      </span>
                      <span>
                        &nbsp;&nbsp;
                        <img
                          type="image/svg+xml"
                          width="12px"
                          style={{ marginTop: "-4px" }}
                          src={calendar}
                          alt="calender"
                        />
                      </span>
                    </label>
                  }
                  ref={(interviewDate) => (this.dateSelect = interviewDate)}
                />
              </label>
            </div>
          </Col>
          <Col
            md={2}
            style={{ padding: "0px 17px 0px 19px", backgroundColor: "white" }}
          >
            <div className={classes.filterByAvailability}>
              <span>Time Slot</span>
              <span
                className={classes.filterClear}
                onClick={() => this.clearFilters(2)}
              >
                Clear
              </span>
            </div>
            <div
              style={{ display: "flex", justifyContent: "flex-end" }}
              className={classes.select}
            >
              <select
                id="timeslot"
                name="timeslot"
                className={classes.filterTimeSlot}
                onChange={this.filterByTimeSlot.bind(this)}
              >
                <option value="">Any Time Slot</option>
                <option
                  selected={this.props.timeslotFilter === "8 AM - 11 AM"}
                  value="8 AM - 11 AM"
                  id="8 AM - 11 AM"
                >
                  8 AM - 11 AM
                </option>
                <option
                  selected={this.props.timeslotFilter === "11 AM - 2 PM"}
                  value="11 AM - 2 PM"
                  id="11 AM - 2 PM"
                >
                  11 AM - 2 PM
                </option>
                <option
                  selected={this.props.timeslotFilter === "2 PM - 5 PM"}
                  value="2 PM - 5 PM"
                  id="2 PM - 5 PM"
                >
                  2 PM - 5 PM
                </option>
                <option
                  selected={this.props.timeslotFilter === "5 PM - 8 PM"}
                  value="5 PM - 8 PM"
                  id="5 PM - 8 PM"
                >
                  5 PM - 8 PM
                </option>
                <option
                  selected={this.props.timeslotFilter === "8 PM - 11 PM"}
                  value="8 PM - 11 PM"
                  id="8 PM - 11 PM"
                >
                  8 PM - 11 PM
                </option>
              </select>
            </div>
          </Col>
        </Row>

        <Loader
          show={this.props.loader || this.props.notifyFoxmatrixLoader}
          message={<img src={loading} />}
          foregroundStyle={{ color: "#00a99d" }}
          backgroundStyle={{ backgroundColor: "#F3EFEF" }}
        >
          <Row>
            <Col md={12}>
              {this.state.slotError !== "" ? (
                <NewSweetAlert
                  style={{ width: "400px", marginLeft: "-210px" }}
                  warning
                  onConfirm={this.hideAlert_2}
                  confirmBtnBsStyle="none"
                  confirmBtnCssClass="confirmButtonStyle"
                >
                  {this.state.slotError}
                </NewSweetAlert>
              ) : null}
              {this.state.notifyFail === true ? (
                <NewSweetAlert
                  style={{ width: "400px", marginLeft: "-210px" }}
                  warning
                  onConfirm={this.hideAlert_2}
                  confirmBtnBsStyle="none"
                  confirmBtnCssClass="confirmButtonStyle"
                >
                  {`Unable to notify. Please try again`}
                </NewSweetAlert>
              ) : null}

              {this.state.notifySuccess === true ? (
                <NewSweetAlert
                  style={{ width: "400px", marginLeft: "-210px" }}
                  success
                  onConfirm={this.hideAlert_2}
                  confirmBtnBsStyle="none"
                  confirmBtnCssClass="confirmButtonStyle"
                >
                  {`Thank You for notifying us.\r\n We will get back you after onboarding interviewers for this job profile.`}
                </NewSweetAlert>
              ) : null}
              {/* <span className={classes.error}>&nbsp; {this.state.error}</span> */}
            </Col>
          </Row>

          {!this.props.serverErrorStatus ||
          this.props.notifyFoxmatrixNetworkError ? (
            this.state.scheduleInterviewInterviewerList.length !== 0 ? (
              !this.props.scheduleInterviewInterviewerNodata ? (
                <>
                  <Row>
                    <Col
                      md={12}
                      className="table-responsive"
                      style={{ height: "60vh", marginTop: "10px" }}
                    >
                      <table
                        className={classes.scheduleTbl}
                        style={{
                          borderCollapse: "separate",
                          borderSpacing: "0px 0px",
                        }}
                      >
                        <thead>
                          <tr>
                            {/* <th style={{width:"5%"}}> &nbsp; </th> */}
                            <th style={{ width: "5%", zIndex: 500 }}>
                              {" "}
                              &nbsp;{" "}
                            </th>
                            {/* <th style={{width:"18%"}}>Interviewer Name</th> */}
                            <th style={{ width: "26%", paddingLeft: "15px" }}>
                              {this.state.userType == "0"
                                ? labels.counsellorTable
                                : labels.interviewTableSecond}
                            </th>
                            <th style={{ width: "16%" }}>Experience</th>
                            <th style={{ textAlign: "center", width: "14%" }}>
                              Amount
                            </th>
                            {this.state.userType == 0 ? (
                              <th style={{ textAlign: "center", width: "14%" }}>
                                {labels.RatingHeading}
                              </th>
                            ) : (
                              <th style={{ textAlign: "center", width: "14%" }}>
                                Rating
                              </th>
                            )}
                            <th style={{ width: "24%" }}>Availability</th>
                            <th style={{ width: "2%" }}></th>
                          </tr>
                        </thead>
                        <tbody id="interviewer">
                          {this.state.scheduleInterviewInterviewerList.map(
                            (element, index) => {
                              let obj = {
                                id: element.interviewerId,
                                name: element.name,
                                profile: element.profile,
                                experienceInYears: element.experienceInYears,
                                experienceInMonths: element.experienceInMonths,
                              };
                              return (
                                <tr key={index}>
                                  {/* <td >{element.recommendation!=undefined && element.recommendation!=null &&  element.recommendation!=""?(<img title={element.recommendation} style={{position:"relative", top: "-18px",left: "-15px"}} type="image/svg+xml" width="20px" src={recommend} alt="search" />):null}  </td> */}
                                  <td width="5%">
                                    <label className={classes.profile}>
                                      <input
                                        type="radio"
                                        required
                                        id={element.interviewerId}
                                        onClick={(e) => {
                                          // this.props.onRadioSelectInterviewer(
                                          //   e
                                          // );
                                          new Cookies().set(
                                            "CNinterviewerId",
                                            element.interviewerId
                                          );
                                          this.setState({
                                            selectId: element.interviewerId,
                                            interviewerAmount: element.amount,
                                            availabilityModal: true,
                                            interviwerRadioId: obj,
                                            interviewerId:
                                              element.interviewerId,
                                            position: element.profile,
                                            expYears: element.experienceInYears,
                                            expMonths:
                                              element.experienceInMonths,
                                          });
                                          this.props.setAvailability(
                                            element.availability
                                          );
                                        }}
                                        onChange={(e) => this.check(e)}
                                        value={JSON.stringify(obj)}
                                        name="interviewer"
                                        checked={
                                          this.props.interviewerProfileValue
                                            .id == element.interviewerId
                                        }
                                      />
                                      <span
                                        className={classes.checkmark}
                                      ></span>
                                    </label>
                                    {/* this.state.interviewerId!=element.interviewerId &&  */}
                                  </td>
                                  <td
                                    onClick={() =>
                                      this.handleModal(
                                        element.totalInterviewTaken,
                                        element.email,
                                        element.interviewerProfilePicPath,
                                        element.interviewerId
                                      )
                                    }
                                  >
                                    {element.name}
                                  </td>

                                  <td
                                    onClick={() =>
                                      this.handleModal(
                                        element.totalInterviewTaken,
                                        element.email,
                                        element.interviewerProfilePicPath,
                                        element.interviewerId
                                      )
                                    }
                                  >
                                    {element.profile} with{" "}
                                    {element.experienceInYears}{" "}
                                    {element.experienceInYears <= 1
                                      ? "year"
                                      : "years"}{" "}
                                    {element.experienceInMonths}{" "}
                                    {element.experienceInMonths <= 1
                                      ? "month"
                                      : "months"}{" "}
                                    of experience
                                  </td>

                                  <td
                                    onClick={() =>
                                      this.handleModal(
                                        element.totalInterviewTaken,
                                        element.email,
                                        element.interviewerProfilePicPath,
                                        element.interviewerId
                                      )
                                    }
                                    style={{ textAlign: "center" }}
                                  >
                                    {element.amount}
                                  </td>
                                  <td
                                    onClick={() =>
                                      this.handleModal(
                                        element.totalInterviewTaken,
                                        element.email,
                                        element.interviewerProfilePicPath,
                                        element.interviewerId
                                      )
                                    }
                                    style={{ textAlign: "center" }}
                                  >
                                    {element.averageRating}
                                  </td>
                                  <td
                                    style={{
                                      color: "#fbb03b",
                                      textDecoration: "underline",
                                      width: "18%",
                                    }}
                                    onClick={() => {
                                      this.props.setAvailability(
                                        element.availability
                                      );
                                      new Cookies().set(
                                        "CNinterviewerId",
                                        element.interviewerId
                                      );
                                      this.setState({
                                        availabilityModal: true,
                                        interviwerRadioId: obj,
                                        interviewerId: element.interviewerId,
                                        interviewerAmount: element.amount,
                                        interviwerRadioId: obj,
                                        interviewerId: element.interviewerId,
                                        position: element.profile,
                                        expYears: element.experienceInYears,
                                        expMonths: element.experienceInMonths,
                                      });
                                    }}
                                  >
                                    {this.props.interviewerProfileValue.id ==
                                    element.interviewerId
                                      ? this.props.text
                                      : "View Slot"}
                                  </td>
                                  <td></td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>
                    </Col>
                  </Row>
                  <div className={classes.footer}>
                    <Row>
                      <Col md={1}></Col>
                      <Col md={2}>
                        {/* <Button
                          type="button"
                          onClick={this.props.gotoSelectCandidate}
                          variant="warning"
                          className={classes.nextBtn}
                        >
                          {" "}
                          Previous{" "}
                        </Button> */}
                      </Col>
                      <Col md={6}>
                        {this.props.records > 1 ? (
                          <Pagination
                            activePage={this.state.currentPage}
                            pageRangeDisplayed={this.props.records}
                            onPageChange={this.onPageChange}
                            onLeftChange={this.onLeftChange}
                            onRightChange={this.onRightChange}
                          />
                        ) : null}
                      </Col>
                      <Col md={2}>
                        <Form onSubmit={(e) => this.handleSubmit(e)}>
                          <Button
                            type="button"
                            onClick={() => {
                              if (
                                this.state.remainingBalance <
                                this.state.interviewerAmount
                              ) {
                                this.SchedulingCouncelling();
                              } else {
                                this.setState({
                                  slotError: "Your account balance is too low",
                                });
                              }
                            }}
                            variant="warning"
                            className={classes.nextBtn}
                          >
                            {" "}
                            {labels.scheduleBtn}{" "}
                          </Button>
                        </Form>
                      </Col>
                      <Col md={1}></Col>
                    </Row>
                  </div>
                  <br />
                </>
              ) : (
                <>
                  {" "}
                  <NoDataErrorScreen msg="No results found" />
                  <Row className="justify-content-md-center">
                    <Col md={3}>
                      <Button
                        type="button"
                        variant="warning"
                        className={`${classes.searchButton} ${classes.btnWarning}`}
                        style={{ marginLeft: "27%" }}
                        onClick={() => this.notifyInterviewer()}
                      >
                        Notify FoxMatrix
                      </Button>
                    </Col>
                  </Row>
                  <div className={classes.footer}>
                    <Row>
                      <Col md={1}></Col>
                      <Col md={2}>
                        {/* <Button
                          type="button"
                          onClick={this.props.gotoSelectCandidate}
                          variant="warning"
                          className={classes.nextBtn}
                        >
                          {" "}
                          Previous{" "}
                        </Button> */}
                      </Col>
                    </Row>
                  </div>
                </>
              )
            ) : (
              <>
                {" "}
                <NoDataErrorScreen msg="Nothing Found" />
                <Row className="justify-content-md-center">
                  <Col md={3}>
                    <Button
                      type="button"
                      variant="warning"
                      className={`${classes.searchButton} ${classes.btnWarning}`}
                      style={{ marginLeft: "10%", cursor: "pointer" }}
                      onClick={() => this.notifyInterviewer()}
                    >
                      Notify FoxMatrix
                    </Button>
                  </Col>
                </Row>
                <div className={classes.footer}>
                  <Row>
                    <Col md={1}></Col>
                    <Col md={2}>
                      {/* <Button
                        type="button"
                        onClick={this.props.gotoSelectCandidate}
                        variant="warning"
                        className={classes.nextBtn}
                      >
                        {" "}
                        Previous{" "}
                      </Button> */}
                    </Col>
                  </Row>
                </div>
              </>
            )
          ) : (
            <>
              {" "}
              <ServerErrorScreen />{" "}
              <div className={classes.footer}>
                <Row>
                  <Col md={1}></Col>
                  <Col md={2}>
                    {/* <Button
                      type="button"
                      onClick={this.props.gotoSelectCandidate}
                      variant="warning"
                      className={classes.nextBtn}
                    >
                      {" "}
                      Previous{" "}
                    </Button> */}
                  </Col>
                </Row>
              </div>
            </>
          )}
          {this.state.show ? (
            <Modal
              email={this.state.email}
              image={this.state.image}
              show={this.state.show}
              id={this.state.id}
              handleClose={this.handleModal}
              totalInterviewTaken={this.state.totalInterviewTaken}
            />
          ) : null}
          {this.props.scheduleInterviewEStatus ? (
            <SweetAlert
              style={{
                width: "400px",
                marginLeft: "-210px",
              }}
              //type = "success"
              custom
              customIcon={Check}
              confirmBtnBsStyle="none"
              // confirmBtnCssClass={classes.confirmButtonStyle}
              confirmBtnStyle={{
                width: "80px",
                height: "35px",
                outline: "none",
                fontWeight: "bold",
                border: "none",
                borderRadius: "20px",
                backgroundColor: "#fbb03b",
                color: "white",
                fontSize: "16px",
              }}
              onConfirm={() => {
                this.props.history.push("/interview");
                // this.props.clearAllFilter();
                window.location.reload();
              }}
              focusConfirm={true}
            >
              Scheduled Successfully!
            </SweetAlert>
          ) : null}
          {this.props.scheduleInterviewErrorMsg ? (
            <SweetAlert
              style={{ width: "400px", marginLeft: "-210px" }}
              type="danger"
              show="true"
              confirmBtnStyle={{
                background: "#fbb03b",
                borderRadius: "50px",
                height: "35px",
                fontSize: "16px",
                width: "80px",
                border: "none",
                padding: "0.375rem 0.75rem",
              }}
              onConfirm={() => {
                this.props.history.push("/interview");
                this.props.scheduleInterviewResetState();
                // this.props.clearAllFilter();

                window.location.reload();
              }}
            >
              {this.props.scheduleInterviewErrorMsg}
            </SweetAlert>
          ) : null}
          {this.props.checkDuplicateResult ? (
            <SweetAlert
              style={{ width: "420px", marginLeft: "-210px" }}
              type="warning"
              show="true"
              confirmBtnStyle={{
                background: "#fbb03b",
                borderRadius: "50px",
                height: "35px",
                fontSize: "16px",
                border: "none",
                padding: "0.375rem 0.75rem",
              }}
              cancelBtnStyle={{
                color: "#fbb03b",
                backgroundColor: "#fff",
                borderRadius: "50px",
                height: "35px",
                fontSize: "16px",
                fontWeight: "600",
                border: "2px solid #fbb03b",
                padding: "0.375rem 0.75rem",
                textDecoration: "none",
              }}
              showCancel="true"
              confirmBtnText="Proceed"
              onCancel={() => {
                this.props.gotoSelectInterviewer();
              }}
              onConfirm={() => {
                this.handleSubmit();
              }}
            >
              {this.props.checkDuplicateResultMsg}
            </SweetAlert>
          ) : null}
        </Loader>

        {this.state.availabilityModal ? (
          <AvailabilitySecond
            data={this.props.availability}
            id={this.state.interviewerId}
            show={this.state.availabilityModal}
            availabilityModalHandler={this.availabilityModalHandler}
            onRadioSelect={this.props.changeText}
            obj={JSON.stringify(this.state.interviwerRadioId)}
            text={this.props.selectedText}
            index={this.props.index}
            interviewerProfileValue={this.props.interviewerProfileValue}
          />
        ) : null}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loader: state.employeeReducer.loader,
    scheduleInterviewInterviewerList:
      state.employeeReducer.scheduleInterviewInterviewerList,
    records: state.employeeReducer.records,
    serverErrorStatus: state.employeeReducer.serverErrorStatus,
    scheduleInterviewInterviewerNodata:
      state.employeeReducer.scheduleInterviewInterviewerNodata,
    sufficientBalance: state.employeeReducer.sufficientBalance,
    remainingBalance: state.employeeReducer.remainingBalance,

    notifyFoxmatrixLoader: state.employeeReducer.notifyFoxmatrixLoader,
    notifyFoxmatrixSuceess: state.employeeReducer.notifyFoxmatrixSuceess,
    notifyFoxmatrixFailMsg: state.employeeReducer.notifyFoxmatrixFailMsg,
    notifyFoxmatrixNetworkError:
      state.employeeReducer.notifyFoxmatrixNetworkError,

    availabilityFilter: state.employeeReducer.availabilityFilter,
    type: state.employeeReducer.typeDate,
    nameFilter: state.employeeReducer.nameFilter,
    timeslotFilter: state.employeeReducer.timeslotFilter,
    scheduleInterviewEStatus: state.employeeReducer.scheduleInterviewEStatus,
    checkDuplicateResult: state.employeeReducer.checkDuplicateResult,
    checkDuplicateResultMsg: state.employeeReducer.checkDuplicateResultMsg,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getScheduleInterviwerList: (page, data) =>
      dispatch(actionTypes.getScheduleInterviwerList(page, data)),
    scheduleCounselling: (page, data) =>
      dispatch(actionTypes.scheduleCounselling(page, data)),
    notifyFoxmatrix: (data) => dispatch(actionTypes.notifyFoxmatrix(data)),
    clearStateNotify: () => dispatch(actionTypes.clearStateNotify()),
    saveFilters: (date, type) => dispatch(actionTypes.saveFilters(date, type)),
    saveFilterByName: (data) => dispatch(actionTypes.saveFilterByName(data)),
    saveFilterTimeSlot: (data) =>
      dispatch(actionTypes.saveFilterTimeSlot(data)),
  };
};

// export default connect(mapStateToProps, mapDispatchToProps)(candidateProfile);
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(candidateProfile)
);
